import React from "react";
import Link from "next/link";

interface Props {
  playlist: Playlist;
}

export default function PlaylistItem(props: Props) {
  const playlist = props.playlist;

  return (
    <Link href={`/playlists/${playlist.id}`}>
      <div className="w-full">
        <div className="relative flex flex-col justify-end w-full font-bold text-white rounded-lg h-28 sm:h-32">
          <img
            src={playlist.image?.url || "/angaza-logo.png"}
            alt={playlist.title}
            className="object-cover object-center w-full h-full rounded-lg"
          />
        </div>

        <div className="px-2 py-2">
          <p className="text-xs font-semibold leading-tight truncate overflow-ellipsis">
            {playlist.title}
          </p>
          <p className="text-xs">{playlist.songCount} Songs</p>
        </div>
      </div>
    </Link>
  );
}
